import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { Form, Col, Row, Button, Alert, Card, Container } from 'react-bootstrap';
import { selectOption } from 'src/utils/label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk, faExclamationTriangle, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { NumericFormat } from 'react-number-format';
import FormFieldError from 'src/components/general/FormFieldError';
import { isNotEmptyArray } from 'src/services/validationService';
import { DropdownList } from 'react-widgets';
import { parseFloatOrUndefined } from 'src/utils/utils';
import { tryGetWagesTemplateDetails } from 'src/redux/wageTemplate/wageTemplateActionCreator';
import { getWageTemplateListIsFetching } from 'src/redux/wageTemplate/wageTemplateReducer';
import { tryListConceptsSelect } from "src/redux/conceptRequest/conceptRequestActionCreator";
import { getConceptListSelectData, getConceptListSelectIsFetching } from "src/redux/conceptRequest/conceptRequestReducer";
import { tryListSubconcepts } from 'src/redux/subconcept/subconceptActionCreator';
import { tryGetRecruitmentMethod } from 'src/redux/wageTemplate/wageTemplateActionCreator';
import { getRecruitmentMethodsData, getRecruitmentMethodsIsFetching } from 'src/redux/wageTemplate/wageTemplateReducer';
import { push } from 'connected-react-router';
import { PAYROLL_LIST } from 'src/utils/constants';
import InputServiceForm from 'src/components/common/InputServiceForm';
import { getAccessToken } from 'src/redux/login/loginReducer';
import { payrollService } from 'src/services/payrollService';
import { PayrollNewConcepts } from './PayrollNewConcepts';
import { PayrollNewTableConcepts } from './PayrollNewTableConcepts';

const PayrollNewPage = (props) => {
    const dispatch = useDispatch();
    const accessToken = useSelector(state => getAccessToken(state));
    const [serviceId, setServiceId] = useState(2);
    const hookFormMethods = useForm();
    const { handleSubmit, register, control, setValue, errors } = hookFormMethods;
    const settlementOfAssets = {};
    const setSettlementOfAssets = () => {};
    const orderPay = undefined;
    const [methodId, setMethodId] = useState(settlementOfAssets?.wageLiquidationType || '');
    const [salaryTemplate, setSalaryTemplate] = useState('');
    const [description, setDescription] = useState('');
    const [assetConcept, setAssetConcept] = useState('');
    const [subConcept, setSubConcept] = useState('');
    const [item, setItem] = useState('');
    const [code, setCode] = useState('');
    const [liquidAmount, setLiquidAmount] = useState(settlementOfAssets?.netAmount || '');
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalGeneral, setTotalGeneral] = useState(0);
    const [validateConcept, setValidateConcept] = useState(true);
    const defaultParams = {
        page: 0,
        size: 99
    };
    const [wageTemplateList, setWageTemplateList] = useState([]);
    const wageTemplateIsFetching = useSelector(state => getWageTemplateListIsFetching(state));
    const conceptListData = useSelector((state) => (getConceptListSelectData(state)?.records || []).filter(item => item?.administrativeServiceId === serviceId));
    const conceptListIsFetching = useSelector((state) => getConceptListSelectIsFetching(state));
    const [subConceptArray, setSubConceptArray] = useState([]);

    // order function
    const orderList = (list, field) => {
        if (list && field && list.length > 0) {
            return list.sort((a, b) => {
                if (parseInt(a[field]) > parseInt(b[field])) return 1;
                else return -1;
            });
        } else {
            return [];
        }
    };

    // Liquidation list
    const copy = JSON.parse(JSON.stringify(orderList(settlementOfAssets?.wageManagerDetails || [], 'code')));
    const [liquidationList, setLiquidationList] = useState(copy);
    const hasLiquidationList = isNotEmptyArray(liquidationList);

    // Wahe template types
    const recruitmentMethods = useSelector(state => getRecruitmentMethodsData(state));
    const wageTemplateTypesListIsFetching = useSelector(state => getRecruitmentMethodsIsFetching(state));

    //validations messages
    const methodValidationMessage = 'Debe seleccionar un Método de Contratación.';
    const salaryTemplateValidationMessage = 'Debe seleccionar una Plantilla.';
    const liquidAmountValidationMessage = 'Debe cargar el Importe Líquido.';
    const messagesDropDown = { emptyFilter: 'No hay resultados', emptyList: 'No hay resultados' };

    //validations objects
    const methodValidationObj = { required: methodValidationMessage };
    const salaryTemplateValidationObj = { required: salaryTemplateValidationMessage };
    const liquidAmountValidationObj = { required: liquidAmountValidationMessage, validate: value => (value <= 0) ? 'El importe debe ser mayor a cero.' : undefined };
    const negativeGeneralTotal = totalGeneral < 0;

    const withValueLimitImports = (inputObj) => {
        const { value } = inputObj;
        const maxValue = 999999999999.99;
        const minValue = -999999999999.99;
        if (value <= maxValue && value >= minValue || value == '-') return inputObj;
    };

    //concept iteration validation
    const conceptIterationValidation = (arrayWage, objWage) => {
        return arrayWage?.every(obj =>
            objWage?.item !== obj?.item || objWage?.concept !== obj?.concept || objWage?.subConcept !== obj?.subConcept
        );
    };

    const disabledFields = !methodId || wageTemplateIsFetching || conceptListIsFetching || wageTemplateTypesListIsFetching || (methodId==='PASANTIAS' || methodId==='BECAS');

    // handle change
    const handleChangeMethod = (value) => {
        if((methodId==='PASANTIAS' || methodId==='BECAS')) {
            setLiquidationList();
        }
        const paramsToSend = {
            ...defaultParams,
            administrativeServiceId: serviceId,
            type: value
        };
        setMethodId(value);
        setSalaryTemplate('');
        setValue('wageTemplate', '');
        dispatch(tryGetWagesTemplateDetails(paramsToSend)).then(response => {
            const records = response?.records || [];
            setWageTemplateList(records);
        });
        setLiquidationList([]);
    };

    const handleChangeSalarayTemplate = (value) => {
        let formattedData = [];
        setSalaryTemplate(value);
        const wageTemplateItemCodes = wageTemplateList?.find(item => item?.name == value)?.wageTemplateItemCodes;
        if (isNotEmptyArray(wageTemplateItemCodes)) {
            formattedData = wageTemplateItemCodes?.map((item, index) => {
                item = {
                    ...item,
                    concept: item?.concept?.description,
                    subConcept: item?.subConcept?.description,
                    changeAmount: 0,
                    periodAmount: 0
                }
                return item;
            });
        };
        setLiquidationList(orderList(formattedData, 'code'));
    };

    const handleChangeConcept = (value) => {
        const conceptSelected = conceptListData.find(item => item?.id == value);
        const subConceptList = conceptSelected?.subConcept || [];
        setSubConceptArray(subConceptList);
        setAssetConcept(value);
        setSubConcept('');
    };

    const handleChangeDescrption = (value) => {
        setDescription(value);
    };

    const handleChangeLiquidAmount = (inputObj) => {
        const numericValue = inputObj?.floatValue || 0;
        setLiquidAmount(numericValue);
        setValue('liquidAmount', numericValue);
    };

    //calculate total
    const calculateTotal = (list) => {
        setTotalAmount(list?.map((item) => parseFloatOrUndefined(item?.subtotalAmount) || 0)
            .reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
            }, 0)
        );
    };

    const calculateTotalGeneral = (list) => {
        let total = list?.map((item) => parseFloatOrUndefined(item?.subtotalAmount) || 0)
            .reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
            }, 0);
        const result = ((total || 0) + (parseFloatOrUndefined(liquidAmount) || 0));
        setTotalGeneral(result);
    };

    const handleCreatePayroll = async (payrollData) => {
        try {
            const response = await payrollService.createPayroll(accessToken, payrollData);
            
            if (response.ok) {
                console.log("Payroll created successfully");
                dispatch(push(PAYROLL_LIST));
            } else {
                console.error("Error creating payroll:", response.statusText);
            }
        } catch (error) {
            console.error("Error creating payroll:", error);
        }
    };

    const onSubmitForm = (data) => {
        const net_amount_format = liquidAmount || 0;
    
        // Eliminar el id de cada concepto. VER FORMA de no cargarlo
        const cleanedLiquidationList = liquidationList.map(({ id, ...rest }) => rest);
        const dataObj = {
            administrativeServiceId: serviceId,
            description: description || "",
            wageLiquidationType: data?.methodId,
            name: data?.wageTemplate || 'BECA O PASANTIA',
            generalAmount: totalGeneral,
            netAmount: net_amount_format,
            total: totalAmount,
            wageManagerDetails: cleanedLiquidationList
        };
        setAssetConcept('');
        setSubConcept('');
        setItem('');
        setCode('');
        setSettlementOfAssets({ ...dataObj });
        handleCreatePayroll(dataObj);
    };

    const addConcept = () => {
        const conceptObj = conceptListData?.filter((item) => item?.id == assetConcept)[0];
        const subConceptObj = subConceptArray?.filter((item) => item?.id == subConcept)[0];
        const id = Math.random().toString(30).substring(2);
        const params = {
            concept: conceptObj?.description,
            subConcept: subConceptObj?.description,
            item: item,
            code: code,
            periodAmount: undefined,
            changeAmount: undefined,
            subtotalAmount: 0,
            isNew: true
        };
        if (conceptIterationValidation(liquidationList, params)) {
            const copy = JSON.parse(JSON.stringify(liquidationList));
            const newConceptsList = (copy || []).concat({ ...params });
            setLiquidationList(orderList(newConceptsList, 'code'));
            setAssetConcept('');
            setSubConcept('');
            setItem('');
            setCode('');
            setValue('item', '');
            setValue('code', '');
            setValue('concept', '');
            setValue('subconcept', '');
            setSubConceptArray([]);
            setValidateConcept(true);
        } else {
            setValidateConcept(false);
        };
    };

    const [formData, setFormData] = useState({
        administrativeServiceId: '',
    });

    const handleAdministrativeService = value => {
        setServiceId(value);
        setFormData({ ...formData, administrativeServiceId: value });
    };

    useEffect(() => {
        calculateTotal(liquidationList);
    }, [liquidationList]);

    useEffect(() => {
        calculateTotalGeneral(liquidationList);
    }, [liquidationList, liquidAmount]);

    useEffect(() => {
        dispatch(tryListConceptsSelect());
        dispatch(tryGetRecruitmentMethod());
        dispatch(tryListSubconcepts(defaultParams));

        // Edit order pay
        if (settlementOfAssets?.wageManagerDetails?.length > 0) {
            setMethodId(settlementOfAssets?.wageLiquidationType);
            setSalaryTemplate(settlementOfAssets?.name);
            const paramsToSend = {
                ...defaultParams,
                administrativeServiceId: serviceId,
                type: settlementOfAssets?.wageLiquidationType
            };
            dispatch(tryGetWagesTemplateDetails(paramsToSend)).then(response => {
                const records = response?.records || [];
                setWageTemplateList(records);
                setLiquidationList(settlementOfAssets?.wageManagerDetails);
                setLiquidAmount(settlementOfAssets?.netAmount)
            });
        };
    }, []);

    useEffect(() => {
        setSettlementOfAssets(orderPay?.wageManager || {});
        setLiquidationList([]);
        setLiquidAmount(settlementOfAssets?.netAmount || '');
        setSalaryTemplate(settlementOfAssets?.name || '');
    }, [serviceId]);

    return <Container fluid>
        <Card className="mb-3">
            <Card.Header className="h6">Detalle de Liquidación de Haberes</Card.Header>
            <Card.Body>
                <FormProvider {...hookFormMethods}>
                    <Form onSubmit={handleSubmit(onSubmitForm)} autoComplete='off'>
                        <InputServiceForm
                            formData={formData}
                            handleAdministrativeService={handleAdministrativeService}
                        />
                        <Form.Group as={Row}>
                            <Form.Label sm={4} className='text-black-color pr-0 d-flex mandatory-label' column>
                                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                Descripción:
                            </Form.Label>
                            <Col sm={4}>
                                <Form.Control
                                    type="text"
                                    name="description"
                                    ref={register}
                                    placeholder="Descripción"
                                    onChange={(event) => handleChangeDescrption(event?.target?.value)}
                                    maxLength={255}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label sm={4} className='text-black-color pr-0 d-flex mandatory-label' column>
                                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                Método de contratación:
                            </Form.Label>
                            <Col sm={4}>
                                <Form.Control
                                    as="select"
                                    name="methodId"
                                    defaultValue={settlementOfAssets?.wageLiquidationType}
                                    className={"text-black-color"}
                                    ref={register(methodValidationObj)}
                                    onChange={(event) => handleChangeMethod(event.target.value)}
                                    disabled={orderPay}
                                >
                                    <option value={''}>{selectOption}</option>
                                    {
                                        recruitmentMethods?.map((item, idx) => (
                                            <option value={item} key={idx}>
                                                {item.replace(/_/g, ' ')}
                                            </option>
                                        ))
                                    }
                                </Form.Control>
                                <FormFieldError errors={errors?.methodId} />
                            </Col>
                        </Form.Group>
                        { !(methodId==='PASANTIAS' || methodId==='BECAS') &&
                            <Form.Group as={Row}>
                                <Form.Label sm={4} className='text-black-color pr-0 d-flex mandatory-label' column>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                    Plantilla de Haberes:
                                </Form.Label>
                                <Col sm={4}>
                                    <DropdownList
                                        placeholder='Seleccione una plantilla...'
                                        data={wageTemplateList}
                                        allowCreate='onFilter'
                                        name="wageTemplate"
                                        textField='name'
                                        dataKey='name'
                                        filter='contains'
                                        value={salaryTemplate}
                                        defaultValue={settlementOfAssets?.name}
                                        className='w-100 text-black-color'
                                        onChange={value => handleChangeSalarayTemplate(value?.name)}
                                        id='wageTemplate'
                                        messages={messagesDropDown}
                                        selectIcon={<FontAwesomeIcon   icon={faChevronDown} className='text-black-color' />}
                                        disabled={disabledFields || (orderPay != undefined)}
                                    >
                                    </DropdownList>
                                    <FormFieldError errors={errors?.salaryTemplate} />
                                    <Form.Control hidden readOnly ref={register(salaryTemplateValidationObj)} name='wageTemplate' value={salaryTemplate} />
                                </Col>
                            </Form.Group>
                        }
                        <hr color="black" className='' />
                        <PayrollNewConcepts
                            conceptListData={conceptListData}
                            subConceptArray={subConceptArray}
                            assetConcept={assetConcept}
                            subConcept={subConcept}
                            item={item}
                            code={code}
                            salaryTemplate={salaryTemplate}
                            disabledFields={disabledFields}
                            messagesDropDown={messagesDropDown}
                            handleChangeConcept={handleChangeConcept}
                            setSubConcept={setSubConcept}
                            setItem={setItem}
                            setCode={setCode}
                            addConcept={addConcept}
                        />                       
                        {!validateConcept &&
                            <Alert variant='warning' className='mx-3 mb-3'>
                                <FontAwesomeIcon icon={faExclamationTriangle} className='text-black-color mr-3' />
                                El item, concepto y subconcepto ya se utilizaron.
                            </Alert>
                        }
                        {hasLiquidationList &&
                            <PayrollNewTableConcepts
                                liquidationList={liquidationList}
                                totalAmount={totalAmount}
                                withValueLimitImports={withValueLimitImports}
                                setLiquidationList={setLiquidationList}
                            />
                        }
                        <hr color="black" className='' />
                        <Form.Group as={Row}>
                            <Form.Label sm={4} className='text-black-color pr-0 d-flex mandatory-label' column>
                                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                <b>Importe Líquido:</b>
                            </Form.Label>
                            <Col sm={4} className='ml-0'>
                                <NumericFormat
                                    prefix={'$'}
                                    name='liquidAmount'
                                    value={liquidAmount}
                                    className='form-control text-right'
                                    decimalScale={2}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    inputMode='numeric'
                                    allowLeadingZeros={false}
                                    allowNegative={false}
                                    isAllowed={(inputObj) => withValueLimitImports(inputObj)}
                                    onValueChange={(inputObject) => handleChangeLiquidAmount(inputObject)}
                                    getInputRef={register(liquidAmountValidationObj)}
                                />
                                <FormFieldError errors={errors?.liquidAmount} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={4} className='d-flex mandatory-label'>
                                <span className='text-black-color'><b>Total General:</b></span>
                            </Col>
                            <Col sm={4} className='ml-0'>
                                <NumericFormat
                                    prefix={'$'}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    allowLeadingZeros={false}
                                    decimalScale={2}
                                    value={totalGeneral}
                                    className={'form-control text-right'}
                                    readOnly
                                />
                                {negativeGeneralTotal &&
                                    <Alert variant='danger' className='mb-0'>
                                        <FontAwesomeIcon icon={faExclamationTriangle} className='text-black-color mr-3' />
                                        El Total General no puede ser negativo.
                                    </Alert>
                                }
                            </Col>
                        </Form.Group>
                        <div className='d-flex justify-content-around mt-4 mb-4'>
                            <Button
                                type='button'
                                variant='primary'
                                size='lg'
                                onClick={() => dispatch(push(PAYROLL_LIST))}
                            >
                                Cancelar
                            </Button>
                            <Button
                                type='submit'
                                variant='success'
                                size='lg'
                            >
                                Guardar
                            </Button>
                        </div>
                    </Form>
                </FormProvider>
            </Card.Body>
        </Card>
    </Container>
};

export default PayrollNewPage;